import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EmptyStateRoot } from './TimeSeriesChartEmptyState.style';

/** Shown until a target, a date range and at least one series are selected. */
export function TimeSeriesChartEmptyState() {
  const { t } = useTranslation();

  return (
    <EmptyStateRoot data-qa-element-id="time-series-chart-empty-state">
      <img src="svg/tachograph-card-idle.svg" alt="" data-qa-element-id="time-series-chart-empty-state-icon" />
      <Typography variant="h6" align="center" data-testid="time-series-chart-empty-state-title">
        {t('timeSeriesChart.empty.missingParameters')}
      </Typography>
      <Typography variant="body1" align="center" color="text.secondary">
        {t('timeSeriesChart.empty.missingParametersDescription')}
      </Typography>
    </EmptyStateRoot>
  );
}
